'use client';

import { useEffect } from 'react';

/**
 * Inserts a zero-width space after every slash in the print body so long
 * slash-compounds ("whistleblower/interview/HUMINT", URL paths) can wrap;
 * without a break opportunity inside such a token a justified line before it
 * stretches to full width with catastrophic gaps. Skips <style>/<script> so
 * the injected running-header CSS isn't corrupted.
 *
 * Runs in the page (not the PDF render script) so a plain CMD+P print gets
 * the same treatment as `npm run pdf:*`; the negative lookahead keeps it
 * idempotent.
 */
export function PrintTextPrep() {
  useEffect(() => {
    const root = document.querySelector('.print-root');
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentNode?.nodeName;
        if (parent === 'STYLE' || parent === 'SCRIPT') {
          return NodeFilter.FILTER_REJECT;
        }
        return node.nodeValue && node.nodeValue.includes('/')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    });
    const texts: Text[] = [];
    while (walker.nextNode()) texts.push(walker.currentNode as Text);
    for (const t of texts) {
      t.nodeValue = (t.nodeValue ?? '').replace(/\/(?!\u200B)/gu, '/\u200B');
    }
  }, []);
  return null;
}
